import { Component, inject, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import {
  DateFieldTypes,
  FIELD_ICONS,
  FieldTypesEnum,
  NumberFieldTypes,
  TextFieldTypes,
} from '@module-instance/form-builder-modal/common';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoFormModule } from '@shared/modules';

@Component({
  selector: 'app-add-edit-field',
  imports: [MatDialogModule, MatIconModule, CipoFormModule, TranslateModule, CipoDialogHeaderComponent],
  templateUrl: './add-edit-field.component.html',
  styleUrl: './add-edit-field.component.scss',
})
export class AddEditFieldComponent {
  fb = inject(FormBuilder);
  readonly dialogRef = inject(MatDialogRef<AddEditFieldComponent>);
  readonly type = inject<FieldTypesEnum>(MAT_DIALOG_DATA);

  ICONS = FIELD_ICONS;

  form = this.fb.group({
    name: ['', Validators.required],
    label: ['', Validators.required],
    type: [FieldTypesEnum.Text],
    hint: [''],
    defaultValue: [<unknown>undefined],
    multiple: [false],
    required: [false],
    readonly: [false],
    maximumLength: [<number>undefined],
    decimals: [<number>undefined],
    showSeparator: [false],
    isFilter: [false],
  });
  fieldTypes = signal(TextFieldTypes);

  constructor() {
    if (this.type === FieldTypesEnum.Number) {
      this.form.controls.type.setValue(FieldTypesEnum.Number);
      this.fieldTypes.set(NumberFieldTypes);
    } else if (this.type === FieldTypesEnum.DateTime) {
      this.form.controls.type.setValue(FieldTypesEnum.DateTime);
      this.fieldTypes.set(DateFieldTypes);
    }
  }

  saveField() {
    // Save field
  }
}
